angular.module('ui.utils', [
  'ui.scroll',
  'ui.scrollpoint',
  'ui.event',
  'ui.mask',
  'ui.validate',
  'ui.indeterminate',
  'ui.uploader'
]);



// WEBPACK FOOTER //
// ./app/vendor/angular-ui-utils/index.js